export default function getResource(label) {
    const resources = {
        shop: 'Magasiner',
        myStore: 'Mon magasin'
    };

    return resources[label];
}
